import request from "@/utils/request";

export function listBanner(){
    return request.get('/banner/list');
}